import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Section } from 'sa-ui';

import { getInfo } from './reportsActions';
import messages from './reportsMessages';
import './ReportsContainer.scss';

class ReportsContainer extends Component {
  componentDidMount() {
    // this.props.getInfo();
  }

  render() {
    return (
      <Section title={<FormattedMessage {...messages.title} />}>Put your content here</Section>
    );
  }
}

const mapStateToProps = ({ app }) => ({ user: app.user });

export default compose(connect(mapStateToProps, { getInfo }))(ReportsContainer);
